const root = window.Shopify?.routes?.root || '/';
const giftProduct = 16220443181390;
const eligibleProducts = [16217204392270, 16217250234702];
let busy = false;
async function request(path, body) {
  const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
  return data;
}
async function refresh() {
  if (document.querySelector('cart-drawer-component')) document.dispatchEvent(new CustomEvent('alphav:cart-added'));
  if (location.pathname.replace(/\/$/,'').endsWith('/cart')) location.reload();
}
class AlphaVGiftPicker extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-gift-variants]').textContent);
    this.addEventListener('change', this.onChange, {signal:this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
  onChange = async () => {
    if (busy) return;
    const selects = [...this.querySelectorAll('select')];
    const variant = this.variants[Number(selects[0].value)*4 + Number(selects[1].value)];
    const error = this.querySelector('.av-gift-error');
    error.hidden = true;
    if (!variant?.available) { error.textContent=this.dataset.error;error.hidden=false;return; }
    if (!this.hasAttribute('data-cart')) {
      this.dataset.variant=variant.id;
      const image=this.closest('.alphav-bf-gift')?.querySelector('img');
      if(image && variant.image) image.src=variant.image;
      return;
    }
    busy=true;selects.forEach(s=>s.disabled=true);
    try {
      const cart=await request('cart.js');
      if (!cart.items.some(i=>eligibleProducts.includes(i.product_id))) throw new Error('No eligible pack');
      const old=cart.items.filter(i=>i.product_id===giftProduct && i.variant_id!==variant.id);
      const existing=cart.items.find(i=>i.product_id===giftProduct && i.variant_id===variant.id);
      if (!existing) await request('cart/add.js',{items:[{id:variant.id,quantity:1,properties:{_black_friday:'bamboo_socks_gift'}}]});
      const updates=Object.fromEntries(old.map(i=>[i.key,0]));
      if(existing)updates[existing.key]=1;
      if(Object.keys(updates).length) await request('cart/update.js',{updates});
      this.dataset.variant=variant.id;
      await refresh();
    } catch(e) { error.textContent=this.dataset.error;error.hidden=false; }
    finally {busy=false;selects.forEach(s=>s.disabled=false);}
  };
}
if(!customElements.get('alphav-gift-picker'))customElements.define('alphav-gift-picker',AlphaVGiftPicker);
async function reconcile() {
  if(busy || !document.querySelector('alphav-gift-picker[data-cart], a[href*="regalo-sorpresa-black-friday"]'))return;
  busy=true;
  try {
    const cart=await request('cart.js');
    const gifts=cart.items.filter(i=>i.product_id===giftProduct);
    const eligible=cart.items.some(i=>eligibleProducts.includes(i.product_id));
    const updates={};
    const legacy=cart.items.filter(i=>i.product_id===16217232572750);
    if(eligible && legacy.length && !gifts.length) await request('cart/add.js',{items:[{id:61517130137934,quantity:1,properties:{_black_friday:'bamboo_socks_gift'}}]});
    if(eligible || gifts.length) legacy.forEach(i=>updates[i.key]=0);
    gifts.forEach((i,n)=>{const quantity=eligible&&n===0?1:0;if(i.quantity!==quantity)updates[i.key]=quantity;});
    if(Object.keys(updates).length){await request('cart/update.js',{updates});await refresh();}
  }catch(e){console.warn('Could not synchronize Black Friday gift');}
  finally{busy=false;}
}
document.addEventListener('alphav:cart-synced',()=>setTimeout(reconcile,100));
reconcile();
